@if (!isIconCustom) {
  <svg [class]="iconClass" [class.icon-padded]="padded">
    <use [attr.href]="iconHref" [attr.xlink:href]="iconHref"></use>
  </svg>

} @else {
  <i [class]="iconCustomClass" [class.icon-custom-padded]="padded"></i>
}
